<template>
	<layer class="opt_more_g" name="folder">
		<div class="box_opt_menu list_folder_select_type">
			<div class="menu_item" v-for="{fldid, fldname} in folders">
				<a href="javascript:" class="link_menu" @click="callback(fldid)">{{ fldname }}</a>
			</div>
		</div>
	</layer>
</template>

<script>
import Layer from './Layer.vue';

export default {
	components: {Layer},
	props: {
		folders: {
			type: Array,
			default: () => ([])
		},
		callback: {
			type: Function,
			default: () => null
		}
	}
}
</script>
